import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/base/Breadcrumb';

export default function AboutPage() {
  const aboutSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于韩漫在线阅读网',
    description: '韩漫在线阅读网是一个专注于韩国漫画免费阅读的平台，提供热门韩漫推荐、韩漫最新连载更新，涵盖恋爱、奇幻、校园等多种类型韩漫。',
  };

  const features = [
    {
      icon: 'ri-book-open-line',
      title: '海量韩漫资源',
      description: '收录500+部韩国漫画，涵盖恋爱、奇幻、校园、动作、悬疑、搞笑、剧情等各种类型，满足不同读者的阅读偏好。',
    },
    {
      icon: 'ri-refresh-line',
      title: '实时连载更新',
      description: '与韩国同步更新，第一时间提供最新韩漫连载章节，每周都有新内容，让追漫不再等待。',
    },
    {
      icon: 'ri-shield-check-line',
      title: '完全免费阅读',
      description: '无需注册、无需付费，所有韩漫均可免费在线阅读。我们致力于为韩漫爱好者打造无障碍的阅读体验。',
    },
    {
      icon: 'ri-smartphone-line',
      title: '多端适配阅读',
      description: '支持电脑、平板、手机等多种设备访问，随时随地享受韩国漫画免费看的乐趣。',
    },
    {
      icon: 'ri-thumb-up-line',
      title: '精选推荐机制',
      description: '基于阅读量、评分、热度等多维度数据，结合编辑团队的专业评审，为用户推荐最优质的韩漫作品。',
    },
    {
      icon: 'ri-user-heart-line',
      title: '读者社区氛围',
      description: '50万+忠实读者共同选择，在这里你不仅能阅读精彩韩漫，还能参与到热烈的读者讨论中。',
    },
  ];

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main className="pt-20 pb-14 md:pb-20 bg-background-50">
        <script type="application/ld+json">
          {JSON.stringify(aboutSchema)}
        </script>

        <div className="max-w-5xl mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: '关于我们' },
            ]}
          />

          <section className="text-center py-10 md:py-14">
            <h1 className="font-heading text-3xl md:text-4xl text-foreground-900 mb-4">
              关于韩漫在线阅读网
            </h1>
            <p className="text-base md:text-lg text-foreground-500 max-w-2xl mx-auto leading-relaxed">
              我们是一个专注于韩国漫画免费阅读的平台，致力于为每一位韩漫爱好者
              提供最新、最全、最高质量的韩漫在线阅读体验。
            </p>
          </section>

          <section className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-14 md:mb-20">
            {features.map((feature, index) => (
              <div key={index} className="bg-background-100 rounded-lg p-6">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center mb-4">
                  <i className={`${feature.icon} text-lg text-primary-600`}></i>
                </div>
                <h3 className="font-heading text-lg text-foreground-900 mb-2">
                  {feature.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            ))}
          </section>

          <section className="mb-14 md:mb-20">
            <div className="bg-secondary-900 rounded-lg p-8 md:p-10 text-center">
              <div className="w-16 h-16 mx-auto mb-5 rounded-full bg-accent-500/20 flex items-center justify-center">
                <i className="ri-double-quotes-l text-3xl text-accent-400"></i>
              </div>
              <blockquote className="text-lg md:text-xl text-background-100/80 max-w-2xl mx-auto leading-relaxed mb-5 font-heading">
                "我们相信，好的漫画能够跨越国界，连接每一个热爱故事的心灵。
                韩漫在线阅读网的使命，就是让更多人能够轻松享受到
                韩国漫画带来的快乐与感动。"
              </blockquote>
              <p className="text-sm text-background-100/50">
                —— 韩漫在线阅读网 创始人团队
              </p>
            </div>
          </section>

          <section>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-8 text-center">
              联系我们
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-3xl mx-auto">
              <div className="bg-background-100 rounded-lg p-6 text-center">
                <div className="w-10 h-10 mx-auto mb-3 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className="ri-mail-line text-lg text-primary-600"></i>
                </div>
                <h3 className="font-heading text-base text-foreground-900 mb-1">
                  电子邮箱
                </h3>
                <p className="text-sm text-foreground-500">
                  contact@hanman-online.com
                </p>
              </div>
              <div className="bg-background-100 rounded-lg p-6 text-center">
                <div className="w-10 h-10 mx-auto mb-3 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className="ri-map-pin-line text-lg text-primary-600"></i>
                </div>
                <h3 className="font-heading text-base text-foreground-900 mb-1">
                  地址
                </h3>
                <p className="text-sm text-foreground-500">
                  韩国首尔特别市江南区
                </p>
              </div>
              <div className="bg-background-100 rounded-lg p-6 text-center">
                <div className="w-10 h-10 mx-auto mb-3 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className="ri-time-line text-lg text-primary-600"></i>
                </div>
                <h3 className="font-heading text-base text-foreground-900 mb-1">
                  工作时间
                </h3>
                <p className="text-sm text-foreground-500">
                  周一至周五 9:00-18:00
                </p>
              </div>
            </div>
          </section>

          <section className="mt-16 text-center">
            <p className="text-sm text-foreground-400 mb-4">
              准备好开始阅读了吗？
            </p>
            <Link
              to="/"
              className="inline-block px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-base hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              浏览韩漫
            </Link>
          </section>
        </div>
      </main>
      <Footer />
    </>
  );
}